import { Box, Button, Stack, SvgIcon, Typography } from '@mui/material';
import { theme } from '../../theme';
import { Plus, SearchSm } from '../../assets';
import CustomPagination from '../../components/forms/Pagination';
import { useTranslation } from 'react-i18next';

export const EmptyTable = (props: {
  text: string,
  searchTerm?: string,
  onClear: () => void,
  onAdd: () => void,
  addItemText: string,
  onAddIsCreating: boolean,
  onAddIsDisabled?: boolean,
}) => {
  const { t } = useTranslation('common');

  return <Box sx={{
    borderColor: theme.palette.custom.gray[300],
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  }}>
    <Box sx={{
      height: '553.9px',
      display: 'flex',
      flexDirection: 'column', // Align children in a vertical column
      alignItems: 'center',    // Horizontally center the children
      width: '100%',           // Full width of the parent container
    }}>
      <Box
        sx={{
          height: '553.9px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center', // Center children vertically
          alignItems: 'center', // Center children horizontally
          width: '100%',
          borderBottom: '1px solid',
          borderColor: theme.palette.custom.gray[300],
        }}
      >
        <Box sx={{ mb: 4 }}>
          <Box
            sx={{
              minWidth: '48px',
              minHeight: '48px',
              border: '1px solid',
              borderRadius: '10px',
              borderColor: theme.palette.custom.gray[300],
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              boxShadow: '0 1px 2px 1px #1018280D',
            }}
          >
            <SvgIcon>
              <SearchSm />
            </SvgIcon>
          </Box>
        </Box>
        <Box>
          <Typography variant="textMD"
            fontWeight="600">
            {t('emptyTableTitle',
              {
                itemName: props.text,
              })}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', textAlign: 'center', mb: 4 }}>
          <Typography variant="textSM"
            color={theme.palette.custom.gray[600]}
            fontWeight={400}>
            {t('emptyTableText',
              {
                searchTerm: props.searchTerm ? `"${props.searchTerm}" ` : '',
                itemName: props.text,
              })}
          </Typography>
        </Box>
        <Box>
          <Stack spacing={3}
            direction={{ xs: 'column', md: 'row' }}>
            < Button onClick={props.onClear}
              variant="secondary"
              size="md">
              {t('clearSearch')}
            </Button>
            <Button onClick={props.onAdd}
              disabled={props.onAddIsCreating || props.onAddIsDisabled}
              startIcon={<SvgIcon><Plus fill="white" /></SvgIcon>}
              size="md">
              {props.addItemText}
            </Button>
          </Stack>
        </Box>
      </Box>

      <CustomPagination setPage={() => { }}
        page={-1}
        maxPages={0}
        breakpointForChangeDisplay={120000}
        useNoDataMessage={false} />
    </Box >

  </Box >;

};